import { lazy } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { route } from '../config';

const Overview = lazy(() => import('./Overview'));
const Map = lazy(() => import('./Map'));
const Resources = lazy(() => import('./Resources'));
const Reports = lazy(() => import('./Reports'));
const Patients = lazy(() => import('./Patients'));

export default function Statistics() {
  return (
    <>
      <Route path={`${route}/overview`} component={Overview} />
      <Route path={`${route}/map`} component={Map} />
      <Route path={`${route}/resources`} component={Resources} />
      <Route path={`${route}/reports`} component={Reports} />
      <Route path={`${route}/patients`} component={Patients} />
      <Route exact path={route} component={() => <Redirect to={`${route}/overview`} />} />
    </>
  );
}
